// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"c59f8275","167":"f911d84b","189":"00005625","283":"27e81e84","583":"5e9d1b2d","658":"606293b3","734":"436069bd","868":"e09acffe"}[chunkId] + ".chunk.js";
};